/**
 * service-area API host (mobile-api).
 * 서비스지역 리스트/상세, 오픈 알림 신청 등 service-area 도메인 endpoint 의 base URL.
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? ''

/**
 * order API host (onl-api 의 /order prefix).
 * 주문신청 가능여부 확인 등 order 도메인 endpoint 의 base URL.
 * 호출 시 axios `baseURL` 옵션으로 override (인터셉터·헤더는 동일 axios instance 사용).
 */
export const ORDER_API_BASE_URL = import.meta.env.VITE_ORDER_API_BASE_URL ?? ''

/** 어글리랩 API Key — 모든 서비스지역 API 호출에 `x-api-key` 헤더로 주입 */
export const API_KEY = import.meta.env.VITE_API_KEY ?? ''

/** 어글리랩 제휴사 코드 — 모든 서비스지역 API 호출에 `x-biz-code` 헤더로 주입 */
export const BIZ_CODE = import.meta.env.VITE_BIZ_CODE ?? ''

/**
 * Mock 모드 — 명시적 ON 만 활성화.
 *
 * - 기본: false (로컬·dev·stg·prod 모두 실제 API 호출)
 * - mock 데이터로 격리 검증하고 싶을 때만 `.env.local` 에 `VITE_USE_MOCK=true` 명시
 * - production 빌드는 환경변수 무관 항상 false 보장
 */
export const IS_MOCK = import.meta.env.DEV && import.meta.env.VITE_USE_MOCK === 'true'

export const APP_REDIRECT_URL = 'https://www.sugeo.onl/'
export const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN ?? ''
export const MIXPANEL_DEBUG = import.meta.env.VITE_MIXPANEL_DEBUG === 'true'

export const BRIDGE_READY_TIMEOUT_MS = 5000
export const API_TIMEOUT_MS = 5000
